export default defineNuxtRouteMiddleware(async (to) => {
  // Only apply to /administrace/klinika/* routes
  if (!to.path.startsWith('/administrace/klinika')) return

  if (import.meta.server) return

  const { user, pending } = useUser()

  // Wait for user data to load
  while (pending.value) {
    await new Promise(resolve => setTimeout(resolve, 50))
  }

  if (!user.value || user.value.role !== 'CLINIC_OWNER') {
    return navigateTo('/administrace')
  }
})
